


























































































































































































































































import Component from 'vue-class-component';
import AgentsCriteriaComponent from '@/containers/account/agents/criteria/agents-criteria.vue';
import { ISearchBody } from '@/entities/search-body.interface';
import { IPaging } from '@/entities/paging.interface';
import { IAgentListItem } from '@/entities/agents/agent-list-item.interface';
import agentsApi from '@/api/agents.api';
import { MasterPageCriteria } from '@/components/base/master/master-page-criteria';
import { ISort } from '@/entities/sort.interface';
import { IConfirm } from '@/entities/confirm.interface';
import * as types from '@/store/types';
import { IDictionary } from '../../../entities/dictionary.interface';
import { IListItem } from '../../../entities/list-item.interface';
import { ICompany } from '../../../entities/offices/company.interface';
import { IUpdateStatus } from '@/entities/update-status.interface';
import { mapGetters } from 'vuex';

@Component({
    components: {
        'app-agents-criteria': AgentsCriteriaComponent
    },
    computed: mapGetters({
        superAdminPermissions: types.AUTH_HAS_SUPERADMIN_PERMISSIONS
    })
})
export default class AgentsMaster extends MasterPageCriteria {
    public items: IAgentListItem[] = [];

    protected defaultSort: ISort = {
        field: 'username',
        asc: true
    };

    public list(body: ISearchBody): Promise<IPaging<IAgentListItem>> {
        return agentsApi.list(body);
    }

    public activate(item: IAgentListItem) {
        this.updateStatus(item, { active: true });
    }

    public suspend(item: IAgentListItem) {
        this.updateStatus(item, { active: false });
    }

    public show(item: IAgentListItem) {
        this.updateStatus(item, { hidden: false });
    }

    public hide(item: IAgentListItem) {
        this.updateStatus(item, { hidden: true });
    }
    public enableLogin(item: IAgentListItem) {
        this.updateStatus(item, { loginBlocked: false });
    }
    public disableLogin(item: IAgentListItem) {
        this.updateStatus(item, { loginBlocked: true });
    }

    public activateSelected() {
        this.updateStatusForSelected(
            { active: true },
            'Are you sure to activate selected agents?'
        );
    }

    public suspendSelected() {
        this.updateStatusForSelected(
            { active: false },
            'Are you sure to suspend selected agents?'
        );
    }

    public enableSelected() {
        this.updateStatusForSelected(
            { loginBlocked: false },
            'Are you sure to enable login for selected agents?'
        );
    }

    public disableSelected() {
        this.updateStatusForSelected(
            { loginBlocked: true },
            'Are you sure to disable login for selected agents?'
        );
    }


    private async updateStatus(
        item: IAgentListItem,
        model: IUpdateStatus,
        alertText: string = null
    ) {
        this.selected = [];
        this.updateItem({ ...item, ...model });
        await agentsApi.updateStatusBatch([item.id], model);
    }

    private async updateStatusForSelected(
        model: IUpdateStatus,
        alertText: string
    ) {
        let afterFn = async (closeFn: () => void) => {
            const ids = [...this.selected];
            this.selected = [];
            this.items = this.items.map((x) => {
                if (ids.indexOf(x.id) === -1) {
                    return x;
                } else {
                    return { ...x, ...model };
                }
            });
            try {
                await agentsApi.updateStatusBatch(ids, model);
            } finally {
                closeFn();
            }
        };

        let payload: IConfirm = {
            heading: alertText,
            afterFn
        };

        this.$store.dispatch(types.SHOW_CONFIRM, payload);
    }

    private updateItem(item: IAgentListItem) {
        this.items = this.items.map((x) => {
            if (x.id !== item.id) {
                return x;
            } else {
                return item;
            }
        });
    }
}
